import { render } from "./MyFileUploader.vue?vue&type=template&id=79a3fb44"
import script from "./MyFileUploader.vue?vue&type=script&lang=js"
export * from "./MyFileUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__